import React from "react";

export default function DetailsCard({
  img_url,
  title,
  value,
  className,
  selected,
}) {
  return (
    <div
      className={`h-full flex gap-3 items-center p-3 py-4  rounded-xl transition-all duration-300 ease-in-out ${className} ${
        selected
          ? "bg-white text-black rounded-b-none  " // Add padding at the bottom when selected
          : "bg-blue-500 text-white pb-4" // Default padding at the bottom
      }`}
    >
      <div>
        <img src={img_url} alt="" />
      </div>
      <div>
        <p
          className={`font-normal text-xs ${
            selected ? "text-slate-500" : "text-black"
          }`}
        >
          {title}
        </p>
        <span className="text-lg font-semibold">{value}</span>
      </div>
    </div>
  );
}
